import { CardView } from "common/views/card/Card.view";
import { Fragment } from "core/components/FragmentProvider";

export const card: Fragment<any> = {
	name: "Card",
	component: ({children}) => (
		<CardView viewKey="cartItems.item">
			{children}
		</CardView>
	)
};



// WEBPACK FOOTER //
// ./src/panels/catalog/cart/fragments/cartItemContainerFragments.tsx